// extracted by mini-css-extract-plugin
export default {"Block":"Block_Block__qFoRg","Left":"Block_Left__dSJq4","StraightLine":"Block_StraightLine__6954d","Right":"Block_Right__0Q+5c","RightTitle":"Block_RightTitle__RThdk"};